import { render } from "./RequestIOU.vue?vue&type=template&id=39d2ae1b&scoped=true"
import script from "./RequestIOU.vue?vue&type=script&lang=js"
export * from "./RequestIOU.vue?vue&type=script&lang=js"

import "./RequestIOU.vue?vue&type=style&index=0&id=39d2ae1b&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d2ae1b"]])

export default __exports__